module.exports = __webpack_public_path__ + "img/tablets.80fbaf11.png";